import React, { useEffect, useState } from 'react'
import { getErrorMessage } from '../../../utils';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import LavorisService from '../../../services/LavorisService';
import { useAlert } from '../../../hooks/useAlert';
import { ChatbotSessionMessage } from '../../../services/Absences/Absences.type';
import { Modal } from '../../../components/others/Modal';
import moment from 'moment';


type TProps = {
    show: boolean;
    urlTittle: string;
    onClose?: Function;
};

const ChatbotCloseSessionMessage = ({
    show, urlTittle, onClose
}: TProps) => {
    const LavorisInstance = LavorisService.getInstance();
    const styles = "text-2xl text-red-500 font-bold";
    const { showAlert } = useAlert();
    const [message, setMessage] = useState<ChatbotSessionMessage>()
    const [isReady, setIsReady] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const id: string = searchParams.get("rowId") || "";


    const getMessage = async () => {
        try {
            const message = await LavorisInstance.AbsencesServices.getChatbotClosedMessageByAbsId(id);
            if (!message) {
                showAlert('No hay mensajes')
            }
            setMessage(message)
            setIsReady(true);

        } catch (err) {
            console.log(err)
            showAlert(getErrorMessage({ title: "Error", err }))
        }
    }
    useEffect(() => {
        const getData = async () => {
            await getMessage()
        }
        getData()
    }, [id])



    if (!isReady) {
        return <Modal
            show={show}
            titleStyle={styles}
            urlTittle={urlTittle}
            onClose={() => onClose?.()}
        >
            <h1 className="w-full flex justify-center animate-pulse text-red-500 text-xl">Cargando...</h1>
        </Modal>
    };


    return (
        <Modal
            show={show}
            titleStyle={styles}
            urlTittle={urlTittle}
            onClose={() => onClose?.()}
        >
            <div className='flex flex-col gap-3 w-80 mx-auto rounded-sm border-4 border-red-600 p-2'>
                <span className="text-black font-bold text-center p-2">Fecha: {moment(message?.updated_date).subtract(3, 'hours').format('DD/MM/YYYY HH:mm')}</span>
                <span className="text-black font-bold text-center p-2"> {message?.message || '---'}</span>
            </div>
        </Modal>
    )
}

export default ChatbotCloseSessionMessage